"use strict";

var _toConsumableArray = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findSuggestion = findSuggestion;
var min = Math.min;

function levenshtein(a, b) {
  var t = [],
      u = [],
      i,
      j;
  var m = a.length,
      n = b.length;

  if (!m) {
    return n;
  }

  if (!n) {
    return m;
  }

  for (j = 0; j <= n; j++) {
    t[j] = j;
  }

  for (i = 1; i <= m; i++) {
    for (u = [i], j = 1; j <= n; j++) {
      u[j] = a[i - 1] === b[j - 1] ? t[j - 1] : min(t[j - 1], t[j], u[j - 1]) + 1;
    }

    t = u;
  }

  return u[n];
}

function findSuggestion(str, arr) {
  var distances = arr.map(function (el) {
    return levenshtein(el, str);
  });
  return arr[distances.indexOf(min.apply(void 0, _toConsumableArray(distances)))];
}